import React from 'react';
import clsx from 'clsx';

import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';

import GoalProgressCircle from 'components/FinancialCheckup/FinancialDashboard/GoalsSection/GoalProgressCircle';
import RecommendedActions from 'components/FinancialCheckup/FinancialDashboard/GoalsSection/RecommendedActions';
import { Goal, isCreditScoreGoal } from 'components/FinancialCheckup/FinancialDashboard/GoalsSection';
import { ReactComponent as ArrowUpIcon } from 'images/arrow-up.svg';
import HighlightBadge from 'components/HighlightBadge';

import styles from './GoalCard.module.scss';

const GoalCard: React.FC<{
  goal: Goal;
}> = ({ goal }) => {
  const isComingSoon = isCreditScoreGoal(goal);

  // Use placeholder values for coming soon goals
  const displayPercentage = isComingSoon ? 100 : goal.percentage;
  const displayValue = isComingSoon ? '---' : goal.currentValue;
  const value = isComingSoon ? 800 : +goal.currentValue;

  return (
    <ActionCard variant={ActionCardVariant.White}>
      <div className={styles.cardWrapper}>
        <div className={styles.cardContent}>
          <h3 className={styles.goalName}>{goal.name}</h3>
          <div className={styles.progressSection}>
            <GoalProgressCircle percentage={displayPercentage} type={goal.type} value={value} />
            <div className={styles.amountSection}>
              <div className={styles.amounts}>
                <span className={styles.currentAmount}>{displayValue}</span>
                {!isComingSoon && goal.labelText && <span className={styles.targetAmount}>{goal.labelText}</span>}
                {!isComingSoon && isCreditScoreGoal(goal) && goal.changeValue !== undefined && (
                  <div
                    className={clsx(styles.changeIndicator, {
                      [styles.changeNegative]: goal.changeValue < 0,
                      [styles.changePositive]: goal.changeValue >= 0,
                    })}
                  >
                    <ArrowUpIcon
                      className={clsx(styles.arrowIcon, { [styles.arrowIconNegative]: goal.changeValue < 0 })}
                    />
                    <span className={styles.changeValue}>
                      {goal.changeValue >= 0 ? '+' : ''}
                      {goal.changeValue} {Math.abs(goal.changeValue) === 1 ? 'point' : 'points'}
                    </span>
                  </div>
                )}
              </div>
              {!isComingSoon && (
                <div className={styles.badge}>
                  <span className={styles.badgeEmoji}>{goal.emoji}</span>
                  <HighlightBadge customText={goal.badgeText} />
                </div>
              )}
            </div>
          </div>
        </div>
        {!isComingSoon && <RecommendedActions actions={goal.actions} />}
        {isComingSoon && (
          <div className={styles.comingSoonOverlay}>
            <span className={styles.comingSoonText}>Coming Soon</span>
          </div>
        )}
      </div>
    </ActionCard>
  );
};

export default GoalCard;
